import SEO from '../components/SEO';
import { PageHero } from '../components/Reveal';
import { CONTACT } from '../data/config';

const SECTIONS = [
  {
    title: 'Information We Collect',
    body: 'When you submit a form on CareerWithRaaj (contact, free resources, consultation, or roadmap requests), we collect the details you provide: your name, email address, phone number, current education or profession, career interest, and any message you choose to share.',
  },
  {
    title: 'How We Use Your Information',
    body: 'We use your details only to respond to your enquiry, deliver requested resources, schedule consultations, and provide career guidance. We may occasionally share relevant career resources or updates with you. You can opt out at any time.',
  },
  {
    title: 'What We Never Do',
    body: 'We do not sell, rent, or share your personal information with third parties for their marketing purposes. Your details are used solely to support your career journey with CareerWithRaaj.',
  },
  {
    title: 'Data Security',
    body: 'Your information is stored securely and accessed only by the CareerWithRaaj team for the purposes described above. We retain enquiry data only as long as needed to serve you.',
  },
  {
    title: 'Cookies & Analytics',
    body: 'This website may use analytics tools (such as Google Analytics or Meta Pixel) to understand how visitors use the site and improve the experience. These tools collect anonymised usage data, not personal details.',
  },
  {
    title: 'Your Rights',
    body: 'You can request access to, correction of, or deletion of your personal information at any time by contacting us. We will act on genuine requests promptly.',
  },
  {
    title: 'Changes to This Policy',
    body: 'We may update this Privacy Policy as the platform evolves. The latest version will always be available on this page.',
  },
];

const Privacy = () => (
  <main data-testid="privacy-page">
    <SEO
      title="Privacy Policy | CareerWithRaaj"
      description="How CareerWithRaaj collects, uses, and protects your personal information."
    />
    <PageHero overline="Legal" title="Privacy Policy" description="Last updated: July 2026. Your trust matters — here's exactly how we handle your information." />
    <section className="bg-white py-24">
      <div className="mx-auto max-w-3xl space-y-10 px-6 md:px-12">
        {SECTIONS.map((s, i) => (
          <div key={s.title} data-testid={`privacy-section-${i + 1}`}>
            <h2 className="font-display text-xl font-semibold text-navy md:text-2xl">
              {String(i + 1).padStart(2, '0')}. {s.title}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-600 md:text-base">{s.body}</p>
          </div>
        ))}
        <p className="rounded-2xl border border-line bg-mist p-6 text-sm text-slate-600">
          Questions about this policy? Reach us at <code className="font-mono text-coral">{CONTACT.email}</code>.
        </p>
      </div>
    </section>
  </main>
);

export default Privacy;
